import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme: { spacing } }) => css`
    padding: ${spacing.level6} ${spacing.level6} 0;
    gap: ${spacing.level5};
  `}

  @media (max-width: 768px) {
    ${({ theme: { spacing } }) => css`
      padding: ${spacing.level5} ${spacing.level4} 0;
    `}
  }
`;

export const SectionTitle = styled.h3`
  ${({ theme: { font, colors, spacing } }) => css`
    margin: ${spacing.level4} 0 0;
    padding: 0 ${spacing.level2};
    font-size: ${font.titleSmall.fontSize};
    font-weight: ${font.titleSmall.fontWeight};
    color: ${colors.onSurface};
  `}
`;

export const SectionDescription = styled.p`
  ${({ theme: { font, colors, spacing } }) => css`
    margin: 0 0 ${spacing.level4};
    padding: 0 ${spacing.level2};
    font-size: ${font.bodySmall.fontSize};
    color: ${colors.onSurfaceVariant};
    line-height: 1.5;
  `}
`;

export const MemoryTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  ${({ theme: { font, colors, spacing } }) => css`
    font-size: ${font.bodyMedium.fontSize};

    th,
    td {
      padding: ${spacing.level3} ${spacing.level4};
      text-align: left;
      border-bottom: 1px solid ${colors.outlineVariant};
    }

    th {
      font-weight: ${font.labelMedium.fontWeight};
      color: ${colors.onSurfaceVariant};
      font-size: ${font.labelSmall.fontSize};
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
  `}
`;

export const MemoryText = styled.td`
  max-width: 500px;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  line-height: 1.5;
`;

export const TypeBadge = styled.span`
  font-size: 11px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 100px;
  text-transform: capitalize;

  ${({ theme }) => css`
    background-color: ${theme.colors?.surfaceContainerHigh || '#252540'};
    color: ${theme.colors?.onSurfaceVariant || '#aaa'};
  `}
`;

export const DateCell = styled.td`
  white-space: nowrap;
  font-size: 12px;

  ${({ theme }) => css`
    color: ${theme.colors?.onSurfaceVariant || '#aaa'};
  `}
`;

export const DeleteButton = styled.button<{ disabled?: boolean }>`
  background: transparent;
  border: none;
  padding: 6px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.15s ease;

  ${({ theme, disabled }) => css`
    color: ${theme.colors?.onSurfaceVariant || '#888'};
    cursor: ${disabled ? 'default' : 'pointer'};
    opacity: ${disabled ? 0.3 : 1};

    &:hover:not(:disabled) {
      color: ${theme.colors?.error || '#F44'};
      background-color: ${theme.colors?.errorContainer || 'rgba(255,68,68,0.1)'};
    }
  `}
`;

export const PaginationRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ theme: { spacing } }) => css`
    padding: ${spacing.level3} ${spacing.level4};
  `}
`;

export const PageInfo = styled.span`
  font-size: 12px;

  ${({ theme }) => css`
    color: ${theme.colors?.onSurfaceVariant || '#aaa'};
  `}
`;

export const PageButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const PageButton = styled.button<{ disabled?: boolean }>`
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 12px;
  border-radius: 6px;
  transition: all 0.15s ease;

  ${({ theme, disabled }) => css`
    background-color: ${theme.colors?.surfaceContainerHigh || '#252540'};
    color: ${disabled
      ? theme.colors?.outlineVariant || '#555'
      : theme.colors?.onSurfaceVariant || '#aaa'};
    font-family: ${theme.font?.fontFamily || "'Inter Variable', 'Inter', sans-serif"};
    cursor: ${disabled ? 'default' : 'pointer'};
    opacity: ${disabled ? 0.5 : 1};

    &:hover:not(:disabled) {
      background-color: ${theme.colors?.surfaceContainerHighest || '#2A2A3E'};
    }
  `}
`;

export const EmptyState = styled.p`
  ${({ theme: { font, colors, spacing } }) => css`
    font-size: ${font.bodyMedium.fontSize};
    color: ${colors.onSurfaceVariant};
    padding: ${spacing.level6};
    text-align: center;
  `}
`;

export const LoadingState = styled.p`
  ${({ theme: { font, colors, spacing } }) => css`
    font-size: ${font.bodyMedium.fontSize};
    color: ${colors.onSurfaceVariant};
    padding: ${spacing.level6};
    text-align: center;
  `}
`;

export const ActionCell = styled.td`
  white-space: nowrap;
  text-align: right;
  width: 1%;
`;
